import { css } from '@emotion/core';
import { theme } from '@weave/theme';

export const customSwitchStyle = css`
  > div {
    background-color: ${theme.colors.primary50};
    border-color: ${theme.colors.primary50};
  }
`;
